export const ELinkMenuPlacement = {
	bottomStart: 'bottom-end',
	top: 'top',
} as const;
